<script>
import { HorizontalBar } from "vue-chartjs";
 import moment from 'moment';
export default {
   props: ["datalog"],
  extends: HorizontalBar,
  data: () => ({
      time:[],
      dataSet:[],
  }),
  methods: {
    sortData(){
      this.time = [];
      this.dataSet = [];
      for(var i=0;i<=this.datalog.length;i++){
        let obj = this.datalog[i];
        console.log(obj.date);
        this.time.push(moment(obj.date).format('l'));
        this.dataSet.push(obj.manhour);
         console.log(this.time);
          console.log(this.dataSet);
      }
    },
  },
  created(){
    this.sortData()
  },
  mounted() {
    console.log(this.datalog);
    this.renderChart(
      {
        
        labels: this.time,
        datasets: [
      
      {
        label: "Manhour actual",
        type: "horizontalBar",
        data: this.dataSet,
        backgroundColor: "rgba(247, 15, 15,.5)",
        borderWidth: 3
      }
  ]
      
},
      { 
      responsive: true, 
      maintainAspectRatio: false, 

       legend: {
            position: "bottom"
          },
  	   
  	      scales: {
          	yAxes: [{
              ticks: {
                    // min: 0,
                    // max: 10,
                    // beginAtZero: true,
                    // labelString: 'Manhour Average'
                      }
                    }],
            xAxes: [{
              ticks: {
                    min: 0,
                    // max: 12,
                    beginAtZero: true,
                    labelString: 'Manhour Average'
                      }
                    }],
                  }    
        
      }
      
    );
  }
};
</script>